var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationIconQsub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.16,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F8F2FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.097 11.887H9.305l-.352-7.2h2.464l-.32 7.2zM8.92 14.24c0-.704.576-1.296 1.28-1.296.704 0 1.28.593 1.28 1.296 0 .688-.576 1.28-1.28 1.28-.704 0-1.28-.591-1.28-1.28z",
    fill: "#4A0075"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMCAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeT0iMC4xNjAxNTYiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgcng9IjEwIiBmaWxsPSIjRjhGMkZDIi8+CjxwYXRoIGQ9Ik0xMS4wOTY5IDExLjg4NzVIOS4zMDQ5TDguOTUyOSA0LjY4NzVIMTEuNDE2OUwxMS4wOTY5IDExLjg4NzVaTTguOTIwOSAxNC4yMzk1QzguOTIwOSAxMy41MzU1IDkuNDk2OSAxMi45NDM1IDEwLjIwMDkgMTIuOTQzNUMxMC45MDQ5IDEyLjk0MzUgMTEuNDgwOSAxMy41MzU1IDExLjQ4MDkgMTQuMjM5NUMxMS40ODA5IDE0LjkyNzUgMTAuOTA0OSAxNS41MTk1IDEwLjIwMDkgMTUuNTE5NUM5LjQ5NjkgMTUuNTE5NSA4LjkyMDkgMTQuOTI3NSA4LjkyMDkgMTQuMjM5NVoiIGZpbGw9IiM0QTAwNzUiLz4KPC9zdmc+Cg==";
export { SvgExclamationIconQsub as ReactComponent };